import { ClaimHelper } from "../assets/utils/helpers/claimHelper";
import { AuthConsumer } from "./authProvider";

function RequireAuth(props: any) {
    const { children, requiredPermission, requiredRoles } = props;
    function renderAccessdenied() {
        return <>
            <div className="pt-4 px-4">
                <div className="container-fluid d-flex justify-content-between border-bottom pb-2 mb-3">
                    <h1 className="ms-2">Access Denied!</h1>
                </div>
                <div className="pt-3 px-md-5 px-sm-1">
                    You do not have permission to access this application. We apologize for the inconvenience. If you believe that you have received this message in error, please contact IT Support
                </div>
            </div>
        </>
    }
    return (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect }) => {
                if (isAuthenticated()) {
                    if (ClaimHelper.hasPermission(requiredPermission)) {
                        if (requiredRoles) {
                            if (ClaimHelper.hasRole(requiredRoles)) {
                                return children;
                            } else {
                                return renderAccessdenied()
                            }
                        } else {
                            return children;
                        }
                    }
                    else {
                        return renderAccessdenied()
                    }
                } else {
                    signinRedirect();
                    return <span>loading</span>;
                }
            }}
        </AuthConsumer>
    );
}

export default RequireAuth;
